import Select from "react-select";
import {useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {selectLang, Translate} from "../../app/store/reducers/main/mainReducer";

const SelectYesOrNo = ({onChange, defaultValue, ...props}) => {
    const [value, setValue] = useState(null);
    const lang = useSelector(selectLang);
    const t = Translate;

    const optionsYesOrNO = [
        {value: true, label: t(lang, "edi.common.select_yes_or_no.option.yes")},
        {value: false, label: t(lang, "edi.common.select_yes_or_no.option.no")},
        {value: null, label: t(lang, "edi.common.select_yes_or_no.option.skip")}
    ]

    useEffect(() => {
        if (defaultValue !== null) {
            const val = optionsYesOrNO.find(v => v.value === defaultValue);
            setValue(val);
        } else {
            setValue(optionsYesOrNO[2]);
        }
    }, [defaultValue])

    const onChangeState = option => {
        setValue(option);
        onChange(option);
    }

    const getOptionValue = option => option.value;
    const getOptionLabel = option => t(lang, option.label);

    return (
        <Select
            {...props}
            value={value}
            hideSelectedOptions
            isSearchable={false}
            onChange={onChangeState}
            options={optionsYesOrNO}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
        />
    )
}

export default SelectYesOrNo;